import { API_URL } from "./settings";
import axiosInstance from "./axiosInstance";

export const resetPassword = async (secret, password) => {
     const URL = `${API_URL}/Usuario/ResetPassword/${secret}`
     const axios = axiosInstance();
     const response = await axios.post(URL, { "password": password });     
     return response.data;
};
